import { useMutation } from '@apollo/client'
import { t } from '../utils'
import { useAuth } from '../utils/auth'
import { EXIT_SPOOFING_MUTATION } from '../gql'
import { useRouter } from 'next/router'

const AdminSpoofingBlock: React.FC = () => {
  const { currentUser } = useAuth()
  const router = useRouter()

  const [exitSpoofing] = useMutation(EXIT_SPOOFING_MUTATION, {
    onCompleted: (data) => {
      router.push(`/admin/customers/${data.exitSpoofing.spoofedUserId}`)
    }
  })
  return (
    <>
      {currentUser && currentUser.adminSpoofing && (
        <div className="reactivateBlock" onClick={() => exitSpoofing()}>
          {t('Spoofing mode, click to exit')}
        </div>
      )}
    </>
  )
}

export default AdminSpoofingBlock
